import { HomeTestID } from "@/constants/TestID";
import { UnencryptedStorageKey } from "@/hooks/useUnencryptedStorage";
import RecommendedContentCard from "@/ui/components/home/RecommendedContentCard";

const RecommendedArticleTitle = "Online Eating Disorder Treatment";
const BlurbText =
  "Online Eating Disorder Treatment:\nWhat Recovery Looks Like at Home";
const RecommendedArticleUrl =
  "https://equip.health/articles/treatment-and-recovery/online-eating-disorder-treatment";

const RecommendedArticle = () => {
  return (
    <RecommendedContentCard
      analyticsSource={RecommendedArticle.name}
      analyticsTitle={RecommendedArticleTitle}
      blurbText={BlurbText}
      contentUrl={RecommendedArticleUrl}
      imageSource={require("@/assets/images/components/home_resources/recommended-article.png")}
      storageKey={UnencryptedStorageKey.HomeTabRecommendedArticleDismissed}
      testID={HomeTestID.RecommendedArticle}
    />
  );
};

export default RecommendedArticle;
